import { Component } from '@angular/core';

@Component({
  selector: 'app-srs-access-denied',
  styleUrls: ['standalone-access-denied.component.scss'],
  templateUrl: './standalone-access-denied.component.html',
})
export class StandaloneAccessDeniedComponent {}
